"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubCaseModalBody = SubCaseModalBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const StatusSelectors_1 = require("../../../View/Modals/CommonFormComponents/StatusSelectors");
const FormContext_1 = require("../../../View/Modals/FormContext");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
function SubCaseModalBody({ isEditing, initialData, contextData }) {
    const { register, reset, watch, formState: { errors }, trigger, } = (0, FormContext_1.useFormContext)();
    const parentCase = (initialData?.parentCaseId ? undefined : contextData);
    const _parent = initialData?._parent || parentCase?._parent;
    const parentCaseId = initialData?.parentCaseId || parentCase?.id;
    const _type = watch("_type");
    (0, react_1.useEffect)(() => {
        const resetData = {
            _parent,
            _type: initialData?._type,
            parentCaseId,
            name: initialData?.name,
            description: initialData?.description || "",
            status: initialData?.status ?? MainSetupReact_1.default.CaseStatus.FOR_LATER,
        };
        reset(resetData);
        trigger();
    }, [initialData, reset]);
    function shouldShowNameField() {
        if (!_type)
            return false;
        if (_type?.isUniquePerMilestone)
            return false;
        return true;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !isEditing && (react_1.default.createElement(BussinesObjectSelectors_1.CaseTypeSelector, { milestoneType: _parent?._type, filterFn: (item) => Boolean(item.id) &&
                (parentCase?._type?._allowedSubCaseTypeIds ?? []).includes(item.id), label: "Typ podsprawy" })),
        shouldShowNameField() && (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "name" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nazwa podsprawy"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, placeholder: "Podaj nazw\u0119", isInvalid: !!errors?.name, isValid: !errors?.name, ...register("name") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "name", errors: errors }))),
        react_1.default.createElement(StatusSelectors_1.CaseStatusSelector, { showValidationInfo: true }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "description" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Uwagi"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 3, placeholder: "Dodaj komentarz", isValid: !errors?.description, isInvalid: !!errors?.description, ...register("description") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "description", errors: errors }))));
}
